<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      v-loading="isBusy"
      element-loading-spinner="el-icon-loading"
      label-width="170px"
    >
      <el-form-item prop="send_list" label-width="auto">
        <el-select
          v-model="form.send_list"
          filterable
          clearable
          remote
          placeholder="Search Group"
          :remote-method="search"
          :loading="loading"
          class="form-control"
          @input="onInput"
          popperClass="custom-popper">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="format(item)"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <button class="btn btn-purple px-4 mt-5" @click.prevent="importToSendList">Import</button>
    </el-form>
  </div>
</template>

<script>
import BaseForm from "../../form.vue";
import {addQueryParams} from "../../../libs/url";
import UrlParse from "url-parse";
import QueryString from "qs";

export default {
  extends: BaseForm,

  props: {
    searchUrl: String,
    importUrl: String,
  },

  data() {
    const form = {
      send_list: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      options: [],
      loading: false,
    };
  },

  methods: {
    /**
     * @param {String} text
     */
    search(text) {
      this.loading = true;
      const url = addQueryParams(this.searchUrl, {
        search: text,
        brand_id: _.get(this.getQuery(), 'brand_id')
      });
      axios.get(url)
        .then(this.onSuccess)
        .catch(this.onError)
        .finally(() => {
          this.loading = false;
        })
    },

    /**
     * @param {object} data
     */
    onSuccess({data}) {
      this.options = _.get(data, 'data');
    },

    /**
     * @param {object} response
     */
    onError({response}) {
      this.options = [];
    },

    /**
     * @return {undefined}
     */
    importToSendList() {
      this.isBusy = true;
      axios.post(this.importUrl, this.getForm(), this.getConfig())
        .then(this.storeSuccess)
        .catch(this.handleErrorResponse)
        .then((isBusy = false) => this.isBusy = isBusy);
    },

    /**
     * @param {Object} item
     * @return {string}
     */
    format(item) {
      return _.get(item, 'name');
    },

    /**
     * @return {Object}
     */
    getForm() {
      let form = _.assign({}, this.form, {
        _method: this.method,
      });

      return _.assign({}, form, this.getQuery());
    },

    /**
     * @return {any|{}}
     */
    getQuery() {
      const url = new UrlParse(window.location.href);

      return QueryString.parse(_.trimStart(url.query, '?'));
    },

    /**
     * @param {*} value
     */
    onInput(value) {
      this.$emit('input', value || null);
    },

    /**
     * @param model
     */
    setUpOption(model) {
      this.options = [];
      this.form.send_list = _.get(model, 'id');
      this.options.push(model);
    }
  },
}
</script>

<style scoped>

</style>
